
import { z } from "zod";

export const registerFormSchema = z.object({
  organization_name: z.string().min(1, "Company name is required"),
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address"),
  mobile_number: z.string().min(10, "Phone number is required"),
  city_id: z.number().min(1, "Please select a city"),
  password1: z.string().min(8, "Password must be at least 8 characters"),
  password2: z.string().min(8, "Password must be at least 8 characters"),
  terms_and_conditions_ok: z.boolean().refine(val => val === true, {
    message: "You must accept the Terms and Conditions to continue",
  }),
}).refine((data) => data.password1 === data.password2, {
  message: "Passwords do not match",
  path: ["password2"],
});

export type RegisterFormValues = z.infer<typeof registerFormSchema>;
